module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_98-0d99be49cfe6dae92ef8988d5a27937c.png";